import type MarkdownIt from 'markdown-it';
import type Token from 'markdown-it/lib/token';

const AI_CHART_REGEX = /<secoda-chart>(.*)<\/secoda-chart>/;

function isAiChart(token: Token) {
	return token.content?.match(AI_CHART_REGEX);
}

export default function aiChart(md: MarkdownIt) {
	// Insert a new rule after the "inline" rules are parsed.
	md.core.ruler.after('inline', 'ai_chart', (state) => {
		const { Token } = state;
		const { tokens } = state;

		// Work backwards through the tokens and find text that looks like an ai chart.
		// eslint-disable-next-line no-plusplus
		for (let i = tokens.length - 1; i > 0; i--) {
			const tokenChildren = tokens[i].children || [];
			const matches = tokenChildren.filter(isAiChart);

			if (matches.length && matches.length > 0) {
				let token;

				const nodes: Token[] = [];
				const { content } = matches[0];

				// regex to get the chart id
				const chartId = content.match(
					/<secoda-chart>(.*)<\/secoda-chart>/
				)?.[1];

				token = new Token('ai_chart_open', '', 1);
				token.attrs = [['chart_id', chartId ?? '']];
				nodes.push(token);

				const text = new Token('text', '', 0);
				text.content = '';
				nodes.push(text);

				token = new Token('ai_chart_close', '', -1);
				nodes.push(token);
				tokens.splice(i - 1, 3, ...nodes);
			}
		}

		return false;
	});
}
